<template>
    <span>
        <b-button class="align-baseline mr-2" title="Edit" variant="default" v-if="hasConfigAccess" @click="onEdit">
            <font-awesome-icon :icon="['fas', 'pen-to-square']"></font-awesome-icon>
        </b-button>
        <b-button
            class="align-baseline"
            title="Delete"
            variant="default"
            v-if="hasConfigAccess"
            @click="isDeleteDialogShown = true"
        >
            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </b-button>
        <modal
            id="job-actions-delete-modal"
            title="Delete"
            ok-title="Delete"
            @hide="isDeleteDialogShown = false"
            @cancel="isDeleteDialogShown = false"
            @ok="onDelete"
            :visible="isDeleteDialogShown"
            >Are you sure you want to delete vendor '{{ `${selectedItem.company || selectedItem.id}` }}'?</modal
        >
    </span>
</template>

<script>
    import { mapGetters } from 'vuex';
    import API from '../../../api';
    import Modal from '../../generic/modal/modal.vue';

    export default {
        components: {
            Modal,
        },
        data() {
            return {
                isDeleteDialogShown: false,
            };
        },
        computed: {
            ...mapGetters('workOrders', ['metadata']),
            selectedItem() {
                return this.params.data;
            },
            hasConfigAccess() {
                return this.metadata.permissions && this.metadata.permissions.has_config_access;
            },
        },
        methods: {
            onEdit() {
                this.$router.push(`/app/work-orders/vendor-manager/${this.params.data.id}/edit/`);
            },
            onDelete() {
                this.params.modalData.onDelete(this.params.data);
            },
        },
    };
</script>
